import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { TranslocoModule } from '@jsverse/transloco';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContractControlLayoutSettingsComponent } from 'app/main/pages/contract-control/contract-control-layout-settings/contract-control-layout-settings.component';
import { CustomBoxComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/custom-box/custom-box.component';
import { ExtractSelectedFieldsPipe } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/custom-box/extract-selected-fields.pipe';
import { DefaultBoxComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/default-box/default-box.component';
import { EditLayoutContentComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/edit-layout-content/edit-layout-content.component';
import { AddDocumentTypeButtonNamePipe } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/overview-group/add-document-type-button-name.pipe';
import { DocumentTypeSectionNamePipe } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/overview-group/document-type-section-name.pipe';
import { OverviewGroupComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/overview-group/overview-group.component';
import { ExtractDocumentTypeSectionDataPipe } from 'app/main/pages/settings/documenttype/document-type-settings-modal/pipes/extract-document-type-section-data.pipe';
import { SvgIconsModule } from 'app/main/shared/svg-icons/svg-icons.module';


@NgModule({
  declarations: [
    DefaultBoxComponent,
    CustomBoxComponent,
    ExtractSelectedFieldsPipe,
    EditLayoutContentComponent,
    ContractControlLayoutSettingsComponent,
    OverviewGroupComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    CoreDirectivesModule,
    SvgIconsModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    AddDocumentTypeButtonNamePipe, // Standalone pipe
    DragDropModule,
    ExtractDocumentTypeSectionDataPipe, // Standalone pipe
    DocumentTypeSectionNamePipe // Standalone pipe
  ],
  exports: [
    DefaultBoxComponent,
    CustomBoxComponent,
    ExtractSelectedFieldsPipe,
    EditLayoutContentComponent,
    ContractControlLayoutSettingsComponent,
    OverviewGroupComponent
  ]
})
export class ContractControlSharedModule { }
